import { getIsOnpremise } from "../utils";
import { useCloudNetworkStatus } from "./useCloudNetworkStatus";
import { useOnPremiseNetworkStatus } from "./useOnPremiseNetworkStatus";

export const useNetworkStatus = (): boolean => {
  const isOnPremise = getIsOnpremise();
  const onPremiseStatus = useOnPremiseNetworkStatus();
  const cloudStatus = useCloudNetworkStatus();

  return isOnPremise ? onPremiseStatus : cloudStatus;
};

export default useNetworkStatus;
